/**
 * Component Registry for Stadium House
 * 
 * Inherits from @vibesites-repli-training/theme-stadium-house and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-repli-training/theme-stadium-house/registry';
import { FloorplansList } from './components/FloorplansList';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  FloorplansList,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
